<template>
  <v-app id="inspire">
    <docklist-dialog ref="dockDialog" @saveDialog="loadDock" @cloneDialog="cloneDock"></docklist-dialog>
    <builderlist-dialog ref="builderDialog" @saveDialog="loadBoard"></builderlist-dialog>
    <dock-add ref="dockAdd" @saveDialog="loadNewDock"></dock-add>
    <dock-menu-list ref="dockMenuList" @closeDialog="dockMenuSave"></dock-menu-list>
    <header-set ref="headerSet" @saveDialog="loadHeader"></header-set>
    <v-dialog persistent v-model="dialogDockSetVisible" scrollable width="400">
      <v-card class="dialog_card">
        <div class="loading" v-if="dockSetLoading">
          <v-row align="center" justify="center"  class="fill-height" style="margin:0">
            <v-progress-circular :size="50" :width="7" color="primary" indeterminate >
               </v-progress-circular>
          </v-row>
        </div>
        <v-card-title style="padding: 5px 5px 5px;font-size: 12pt !important;font-weight: bold;" class="dialog_title headline grey lighten-2" primary-title>
           <div class="flex-grow-1"></div>
           Dock Save
          <v-btn icon light @click="cancelDockSave">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding:0;">
           <v-form class="dialog_form" ref="form">
             <v-container>
                <v-row dense>
                      <v-col cols="12">
                          <v-text-field
                            v-model="dock.qname"
                            label="Dock QName"
                            outlined
                            :disabled="!dockIsNew"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="12"   xs="12" >
                      <v-textarea
                        v-model="dock.qdata"
                        label="QData"
                        outlined
                      ></v-textarea>
                    </v-col>
                      <v-col>
                        <v-checkbox hide-details="true" v-model="showShortcutMenu" label="Show shortcut menu"/>
                        <v-row>
                          <v-col cols="6">
                            <v-checkbox style="margin-top:0" hide-details="true" v-model="showQMenu" label="Show QMenu"/>                          
                          </v-col>
                          <v-col cols="6">
                            <v-btn v-if="showQMenu" style="float:right" class="dialog_btn" color="primary" outlined small @click="openDockMenuList">
                              Menu List
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-checkbox style="margin-top:0" hide-details="true" v-model="showQRCode" label="Show QRCode"/>
                        <v-checkbox hide-details="true" v-model="requiredLogin" label="Required login"/>
                      </v-col>
                      <v-col cols="12">
                        <h3 class="text-left">Collection</h3>
                      </v-col>
                      <draggable tag="v-list" v-model="qnameCollection" :componentData="draggable.collectionData" draggable=".item">
                        <v-list-item v-for="(item,index) in qnameCollection" :key="index" class="px-0 item">
                          <v-icon>mdi-drag-vertical</v-icon>
                          <v-text-field
                              v-model="item.title"
                              label="Title"
                              hide-details
                              dense
                              outlined
                            ></v-text-field>
                            <v-text-field
                              class="ml-2"
                              v-model="item.qname"
                              label="QName"
                              hide-details
                              dense
                              outlined
                            ></v-text-field>
                            <v-btn class="ml-2" color="red" small outlined @click="qnameCollection.splice(index,1)">
                                Delete
                            </v-btn>
                        </v-list-item>
                        
                      </draggable>

                    
                  <v-col style="text-align: left;" class="px-0" cols="12" xs="12" >
                    <v-btn class="" color="primary" small outlined @click="qnameCollection.push({title:'',qname:''})">
                        Add qname
                    </v-btn>
                  </v-col>
                  
                </v-row>
             </v-container>
           </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions style="padding:5px;padding-right:10px;">
          <v-btn class="dialog_btn" color="primary" text @click="saveDock">
            Save
          </v-btn>
          <div class="flex-grow-1"></div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-navigation-drawer v-model="drawer" app left>
     <v-row justify="center" align="center">
          <v-col class="text-center">
             <v-form class="righ_form" ref="form">
                
                
                 <v-btn class="form_btn" block  color="primary" @click="openBoardJson" outlined>
                  <v-icon left>open_in_new</v-icon>Show Json
                </v-btn>
              </v-form>
          </v-col>
     </v-row>
    </v-navigation-drawer> -->

    <v-app-bar class="header" app color="grey lighten-3" dense light>
      <v-btn  class="btn_add" color="grey lighten-3" fab small light  @click="gotoHome">
        <v-icon>home</v-icon>
      </v-btn>      
      <div class="flex-grow-1"></div>
      <v-toolbar-title class="header_title"> 
        <img class="logo"  v-if="!dock.qname" :src="JBuilder"/>
        <span class="logo_txt" v-if="dock.qname">{{ dock.qname}}</span>
        <span class="logo_txt" v-if="!dock.qname">Dock Builder</span>
        </v-toolbar-title>
      <div class="flex-grow-1"></div>
       <v-btn style="margin-right:10px;" v-if="layout && layout.length > 0 && (dock.uid == user.Uid || !dock.uid)" class="btn_add" color="grey lighten-3" fab small light  @click="openDockDialog">
        <v-icon>save</v-icon>
      </v-btn>
      <!-- <v-btn style="margin-right:10px;" class="btn_add" color="grey lighten-3" fab small light  @click="addDockItem">
        <v-icon>library_add</v-icon>
      </v-btn> -->
      <v-btn style="margin-right:10px;"  class="btn_add" color="grey lighten-3" fab small light  @click="openDockList">
        <v-icon>border_all</v-icon>
      </v-btn>
       <v-btn style="margin-right:10px;" class="btn_add" color="grey lighten-3" fab small light  @click="newItem">
        <v-icon>autorenew</v-icon>
      </v-btn>
      <v-btn class="btn_add" color="grey lighten-3" fab small light  @click="openBoardJson">
        <v-icon>open_in_new</v-icon>
      </v-btn>      
    
       <header-login style="margin-right:10px;padding-left:10px;"></header-login>
    </v-app-bar>

    <v-main>
             
             <!-- <v-container  fluid class="fill-height2"> -->
               <v-row>
                     <v-app-bar height="60" flat dense>
                       <img style="margin-right:4px;" :src="header.logo" height="45"/>
                        <v-spacer></v-spacer>

                        <h2 class="header_title" :class="{header_margin: header.clock == true}">{{header.title ? header.title : 'no header'}}</h2>
                        <v-btn class="board_icon" icon @click="openHeaderSet">
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <clock v-if="header.clock" ></clock> 
                     </v-app-bar>
               </v-row>
                <v-row style="height:75%;margin-top:10px;"  justify="center"  align="center" >
                   <!-- :style="[$vuetify.breakpoint.sm ? {'height': '75%'} : {'height': '98%'}]" -->
                   <v-card v-if="currentBoard.board" class="overflow-hidden item-box" >
                            <v-app-bar
                              absolute
                              light
                              dense
                              color="grey lighten-2"
                              :elevate-on-scroll="true"
                            >
                            
                            
                              <v-btn class="board_icon" icon @click="removeBoard">
                                <v-icon>delete</v-icon>
                              </v-btn>
                              <div class="flex-grow-1"></div>
                              <h2 style="font-size: 13pt;" >
                                <span v-if="currentBoard.board.qname">{{currentBoard.board.qname}}</span>
                                <!-- <span v-if="item.app">&nbsp;({{item.app}})</span> -->
                              </h2>
                              <div class="flex-grow-1"></div>
                              
                              <v-btn class="board_icon" icon @click="openBoardList">
                                <v-icon>edit</v-icon>
                              </v-btn>
                            </v-app-bar>
                            <v-sheet class="fill-height" >
                              <v-container fluid class="fill-height">     
                                <v-row justify="center" align="center">
                                    <v-col class="text-center">
                                      <span style="font-size: 15pt;text-shadow: 4px 5px 4px #a4a8a9;font-weight: 600;margin-left: 20px;vertical-align: middle;">{{currentBoard.board.qname}}</span>
                                      <!-- <v-btn class="board_icon" icon @click="openDockEdit">
                                        <v-icon>edit</v-icon>
                                      </v-btn> -->
                                    </v-col>
                                </v-row>
                                  
                              </v-container>
                            </v-sheet>
                      </v-card>   
                  <v-col v-if="currentBoard.board == null && currentBoard.title">
                    <v-btn class="btn_addBoard" fab small light @click="openBoardList">
                      <v-icon>add_to_photos</v-icon>
                    </v-btn> 
                     <v-btn style="margin-left:15px;"  class="btn_removeBoard" fab small light @click="removeDock">
                      <v-icon>remove_circle_outline</v-icon>
                    </v-btn>
                    <!-- <v-btn class="board_icon" icon @click="openDockEdit">
                        <v-icon>edit</v-icon>
                    </v-btn>     -->
                  </v-col>
                 </v-row>
             <!-- </v-container> -->
             
           <v-bottom-navigation 
              fixed
              enable-resize-watcher
              bottom
              light
              shift
              height="70px"
              v-model="dockNumber"
              
            >
            <!-- :style="[$vuetify.breakpoint.sm ? {'height': '15%'} : {'height': '10%'}]" -->
              <draggable  v-model="layout" class="d-flex justify-center align-center">
                <transition-group type="transition" :name="'flip-list'">
                  <v-btn class="btn_menu" v-for="(item, index) in layout" height="70px" :key="index" @contextmenu.prevent="showDockEditMenu($event,index)" :ripple="false">
                    <img class="v-icon" v-if="(dockNumber - 1) != index || !item.activeicon" :src="item.icon" height="40px" style="height: 40px;"/> 
                    <img class="v-icon" v-if="(dockNumber - 1) == index && item.activeicon" :src="item.activeicon" height="40px" style="height: 40px;"/> 
                    <span>{{item.title}}</span>
                  </v-btn>
                </transition-group>
              </draggable>
              <v-btn  class="btn_addBoard btn_menu" @click="openDockAdd">
                <v-icon>add</v-icon>
              </v-btn>      
            </v-bottom-navigation>
            <v-menu
                v-model="showMenu"
                :position-x="x"
                :position-y="y"
                absolute
                offset-y
              >
                <v-list>
                  <v-list-item @click="openDockEdit" >
                    <v-list-item-title style="font-size:10pt;">
                      Edit Dock
                       <v-icon style="font-size:13pt;">edit</v-icon>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deleteDock" >
                    <v-list-item-title style="font-size:10pt;color:red;">
                      Delete Dock
                       <v-icon style="font-size:13pt;" color="red">delete</v-icon>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
    </v-main>

    <v-dialog v-model="jsonDialogVisible" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card class="dialog_card" v-on:paste.prevent="pasteJson">
        <v-card-title style="padding: 5px 15px 5px;font-size: 12pt !important;font-weight: bold;" class="dialog_title headline grey lighten-3" primary-title>
            <v-btn style="margin-left:5px;" class="btn_add" color="grey lighten-3" fab small light  @click="jsonDialogVisible = false">
              <v-icon>keyboard_backspace</v-icon>
           </v-btn>
           <div class="flex-grow-1"></div>
           Grid Layout Json
           <div class="flex-grow-1"></div>
           <v-btn style="margin-right:10px;" class="btn_add" color="grey lighten-3" fab small light  @click="view">
              <v-icon>image</v-icon>
           </v-btn>
           <v-btn style="margin-right:10px;" class="btn_add" color="grey lighten-3" fab small light  @click="copy">
              <v-icon>file_copy</v-icon>
           </v-btn>
            <v-btn style="margin-right:10px;" class="btn_add" color="grey lighten-3" fab small light  @click="callPast">
              <v-icon>local_parking</v-icon>
           </v-btn>
          
        </v-card-title>
        <v-card-text>
          <v-container fluid class="fill-height">
            <v-row style="text-align:left;direction:ltr;margin-bottom:50px;" justify="start" align="start">
              <vue-json-pretty :path="'res'" :data="displayJsonString"></vue-json-pretty>
           </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
       
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      color="info"
      :timeout="3000"
      :top="true"
    >
      {{ snakText }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-snackbar  v-model="errorLoading" color="error" :timeout="3000" top="top">
      {{errorMsg}}
    </v-snackbar>
   
  </v-app>
</template>
<script>
//import webmms from "webmms-client";
import JBuilder from '@/assets/logo.png';
import draggable from 'vuedraggable'
import { set as setCookie, get as getCookie, remove as removeCookie } from "es-cookie";
import VueJsonPretty from "vue-json-pretty";
import * as VueGridLayout from "vue-grid-layout";
import { mapState } from "vuex";
import router from "@/router/router";
import previewPage from "@/components/previewPage.vue";
import HeaderLogin from "@/components/HeaderLogin";
import DocklistDialog from "@/components/builder/DockListDialog";
import BuilderlistDialog from "@/components/builder/BuilderListDialog";
import DockAdd from "@/components/dockbuilder/DockAdd";
import DockMenuList from "@/components/dockbuilder/DockMenuList";
import HeaderSet from "@/components/dockbuilder/HeaderSet";
import Clock from "@/components/Clock";
//import urlencode from "obj-urlencode";
import conf from '@/config/config';

var GridLayout = VueGridLayout.GridLayout;
var GridItem = VueGridLayout.GridItem;

export default {
  
    data: () => ({
        JBuilder,
        draggable:{
          collectionData: {
            props: {
              'two-line':true,
              'subheader':true,
              'width':"100%",
              'dense':true,
              'class':"align-center"
            },
          },
        },
        showShortcutMenu:true,
        showQMenu:true,
        qMenuList: [],
        showQRCode:true,
        drawer: null,
        dialogBuilderState: false,
        layout: [],
        header: {
          title: '',
          logo: JBuilder,
          clock: true
        },
        qnameCollection:[],
        requiredLogin:false,
        editIndex:0,
        showMenu: false,
        x: 0,
        y: 0,
        contentData: [],
        currentBoard: {},
        dockNumber: 0,
        colNum: 12,
        rowNum: 2,
        gridMargin: [10, 10],
        dock:{
          name: '',
          uid: '',
          type: 'dock',
          data: {}
        },
        dockIsNew : true,
        dockSetLoading: false,
        itemDrag: true,
        itemResize: true,
        openHeader: false,
        openFooter: false,
        dialogTableVisible: false,
        dialogDockSetVisible: false,
        jsonDialogVisible: false,
        // index: 0,
        areaHeight: 400,
        labelPosition: "right",
        previewShow: false,
        dialogContent: {},
        displayJsonString: {},
        dialogCntWidth: "",
        dialogCntHeight: "",
        dialogCntName: "",
        dialogCntApp: "",
        dialogCntParams: "{}",
        dialogCntData: "{}",
        snakText: '',
        snackbar: false,
        error: true,
        errorLoading: false,
        errorMsg: '',
        mmsReady: false,
        mms: null,
        eiInfo: {
          eiName: '',
          eiTag: '',
          ddn : ''
        },
        webmmsOptions : {
            EiToken: '',
            SToken: '',
            UToken: ''
        },
        yp:{
          ddn: conf.objstore,
          topic: '',
          func: 'object',
          args: null
        },
    }),
    async created() {
       this.startMMS();
    },
    async beforeMount() {
       await this.subscribeMMS();
    },
    beforeDestroy() {
      this.removeEvent();
    },
    computed: {
     ...mapState({
        lang: state => state.global.lang
      }),
  color () {
    switch (this.bottomNav) {
      case 0: return 'blue-grey'
      case 1: return 'teal'
      case 2: return 'brown'
      case 3: return 'indigo'
    }
  },
    user (){
        return this.$store.getters.user;
    },
    gridMarginString: {
      get: function() {
        return JSON.stringify(this.gridMargin);
      },
      set: function(newValue) {
        this.gridMargin = JSON.parse(newValue);
      }
    },
    colNumString: {
      get: function() {
        return this.colNum.toString();
      },
      set: function(newValue) {
        this.colNum = Number(newValue);
      }
    },
    rowNumString: {
      get: function() {
        return this.rowNum.toString();
      },
      set: function(newValue) {
        this.rowNum = Number(newValue);
      }
    },
    layoutError: function() {
      var error = "";
      for (var i = 0; i < this.layout.length; i++) {
        if (this.layout[i]["y"] + this.layout[i]["h"] > this.rowNum) {
          error = "fail";
        }
      }
      return error;
    },
    gridHeight: {
      get: function() {
        var h = 600;
        if (this.openHeader) {
          h -= 55;
        }
        if (this.openFooter) {
          h -= 55;
        }
        if (this.rowNum) {
          h = h - this.gridMargin[1] * (this.rowNum + 1);
          h = Math.round(h / this.rowNum);
        }
        return h;
        // return (this.areaHeight / this.rowNum) - this.gridMargin[1];
      },
      set: function() {
        this.gridHeight = this.areaHeight / this.rowNum - this.gridMargin[1];
      }
    },
    jsonViewDataString: {
      get: function() {
        return JSON.stringify(this.contentData);
      },
      set: function() {
        this.jsonViewDataString = JSON.stringify(this.contentData);
      }
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
  },
  watch: {
    dockNumber: {
        handler (val) {
          if(val)
            this.currentBoard = this.layout[val - 1] || {};
        },
        deep: true   
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      // Code that will run only after the
      // entire view has been rendered
    });
    // this.drawLine();
    // console.log('gridBoard',this.$refs.gridBoard);
  },
  components: {
    GridLayout: GridLayout,
    GridItem: GridItem,
    VueJsonPretty,
    previewPage,
    HeaderLogin,
    BuilderlistDialog,
    DocklistDialog,
    DockAdd,
    DockMenuList,
    HeaderSet,
    draggable,
    Clock
  },
  methods: {
   
    gotoHome() {
      router.push({ name: "home", params: {} });
    },
    showDockEditMenu(e,index) {
        this.showMenu = false;
        this.editIndex=index;
        this.x=e.clientX;
        this.y=e.clientY;
        this.$nextTick(() => {
          this.showMenu = true;
        })
    },
    newItem(){
        this.dock =  {
          qname: '',
          uid: '',
          type: 'dock',
          data: {
            did: Date.now().toString(),
            dock: {}
          }
        };
        this.currentBoard = {};
        this.layout = [];
        this.dockIsNew = true;
    },
    addDockItem(){
      let item = {
        title: null,
        icon: '',
        link: ''
      };

      this.layout.splice(0, 0, item);
    },
    openDockList() {
      this.$refs.dockDialog.dialog = true;
      this.$refs.dockDialog.loadList();
    },
    openDockAdd() {
      this.$refs.dockAdd.isNew = true;
      this.$refs.dockAdd.dialogData = {};
      this.$refs.dockAdd.dialog = true;
      //this.$refs.dockAdd.loadList();
    },
    openDockEdit() {
      this.$refs.dockAdd.isNew = false;  
      this.$refs.dockAdd.dialogData = Object.assign({}, this.layout[this.editIndex]);
      console.log(this.layout[this.editIndex]);
      this.$refs.dockAdd.dialog = true;
      //this.$refs.dockAdd.loadList();
    },
    openDockMenuList(){
      this.$refs.dockMenuList.clear();
      this.$refs.dockMenuList.menuList = this.qMenuList;
      this.$refs.dockMenuList.dialog = true;
    },
    dockMenuSave(menuList) {
      if(menuList)
        this.qMenuList = menuList;
    },
    openHeaderSet() {
      this.$refs.headerSet.dialogData = Object.assign({}, this.header);
      this.$refs.headerSet.dialog = true;
      //this.$refs.dockAdd.loadList();
    },
    openBoardList() {
      this.$refs.builderDialog.dialog = true;
      this.$refs.builderDialog.loadList();
    },
    openBoardJson() {
      this.jsonDialogVisible = true;
      this.displayJsonString = this.layout;
    },    
    copy: async function() {
      this.snakText = 'Copied.';
      this.snackbar = true;
      let text = JSON.stringify(this.displayJsonString);
      await navigator.clipboard.writeText(text);
    },
    callPast: async function(){
        if(navigator.clipboard) {
          let dataTemp = await navigator.clipboard.readText();
          let data = JSON.parse(dataTemp);
          this.displayJsonString = data;   
          this.layout = [];
          this.layout = data;
        }
        document.execCommand('paste');
    },
    pasteJson: function(ev){
        let data = [];
        if(ev && ev.clipboardData){
          data = ev.clipboardData.getData('text/plain');
        }else if(window.clipboardData){
          data = window.clipboardData.getData('text/plain');
        }
        data = JSON.parse(data);
        this.displayJsonString = data; 
        this.layoutDock = data;
      },
    view: function() {
      if(!this.dock.oid){
        this.errorMsg = 'Please first save dock and retry';
        this.errorLoading = true;
        return;
      }

      let url = encodeURI(`https://jboard.ypcloud.com/?q=${this.dock.qname}`);
      window.open(url);
    },
    isJson(item) {
      item = typeof item !== "string" ? JSON.stringify(item) : item;
      try {
        item = JSON.parse(item);
      } catch (e) {
        return false;
      }
      if (typeof item === "object" && item !== null) {
        return true;
      }
      return false;
    },
    openDockDialog(){
        // if(!this.checkWebMMSState())
        //   return;

        this.dialogDockSetVisible = true;
        
    },
    deleteDock(){
      this.layout.splice(this.editIndex,1);
    },
    loadNewDock(val){
        let dock = val;
        console.log(dock);
        if(this.$refs.dockAdd.isNew){
            this.layout.push(Object.assign({}, dock));
            this.dockNumber = this.layout.length;
        }else{
          this.layout[this.editIndex] = Object.assign({}, dock);
          this.dockNumber = this.editIndex;
        }
    },
    loadHeader(){
        let header = this.$refs.headerSet.dialogData;
        this.header = Object.assign({}, header);
    },
    loadDockCreate(){
        this.dock = this.$refs.dockDialog.dialogData;
        this.showShortcutMenu=this.dock.data.dock.showShortcutMenu!=undefined?this.dock.data.dock.showShortcutMenu:true;
        this.showQMenu=this.dock.data.dock.showQMenu!=undefined?this.dock.data.dock.showQMenu:true;
        this.qMenuList=this.dock.data.dock.qMenuList!=undefined?this.dock.data.dock.qMenuList:[];
        this.showQRCode=this.dock.data.dock.showQRCode!=undefined?this.dock.data.dock.showQRCode:true;
        this.requiredLogin=this.dock.data.dock.requiredLogin!=undefined?this.dock.data.dock.requiredLogin:false;
        if(this.dock.data.dock.qnameCollection!=undefined)
          this.qnameCollection=this.dock.data.dock.qnameCollection;
        this.layout = this.dock.data.dock.layout || this.dock.data.dock;
        console.log(this.layout);
        this.layout.forEach((item)=>{
          if(item.board){
          if(!item.board.qname)
            item.board.qname = item.board.name;
          if(!item.board.qcode)
            item.board.qcode = item.board.data.bid;
          }        
        })
        this.header = this.dock.data.dock.header || {title: null, logo: JBuilder, clock: true};
        this.currentBoard = this.layout[0] || {};
        this.dockNumber = 1;
        this.dockIsNew = false;
    },
    loadDock(){
      this.loadDockCreate();
      this.dockIsNew = false;
    },
    cloneDock(){
        this.loadDockCreate();
        this.dockIsNew = true;
    },
    removeBoard(){
      this.currentBoard.board = {};
      this.currentBoard.board = null;
      this.currentBoard.hasBoard = false;
      let docknum = this.dockNumber;
      this.dockNumber = 0;
      this.dockNumber = docknum;
    },
    removeDock(){
      console.log(this.dockNumber);
      this.layout.splice(this.dockNumber - 1, 1);
      this.currentBoard = this.layout[this.dockNumber - 1] || {};
    },
    loadBoard(){
        this.currentBoard.board = null;
        this.layout[this.dockNumber - 1].board = Object.assign({}, this.$refs.builderDialog.dialogData);
        this.currentBoard.hasBoard = true;       
        let docknum = this.dockNumber;
        this.dockNumber = 0;
        this.dockNumber = docknum;
    },
    cancelDockSave(){
        this.dialogDockSetVisible = false;
        if(this.dockIsNew)
          this.dock.name = "";
    },
    async saveDock(){
        // if(!this.checkWebMMSState())
        //   return;

        this.dock.type = 'dock';
        this.dock.uid = this.user.Uid;
        if(!this.dock.data)
          this.dock.data = {};
        this.dock.data.dock = {
            layout: this.layout,
            header: this.header,
            showShortcutMenu:this.showShortcutMenu,
            showQMenu:this.showQMenu,
            qMenuList: this.qMenuList,
            showQRCode:this.showQRCode,
            qnameCollection:this.qnameCollection,
            requiredLogin:this.requiredLogin
        }
        
        
        if(this.dockIsNew || !this.dock.qcode)
          this.dock.qcode = this.dock.data.did || Date.now().toString();
        else
          this.dock.qcode = this.dock.data.did
        
        if(!this.dock.qname)
          this.dock.qname = this.docke.name;

        if (this.dock.qdata && !this.isJson(this.dock.qdata)) {
         this.snakText = 'QData: JSON format error';
         this.snackbar = true;        
          return;
        } 

        if(!this.dock.access)
          this.dock.access = 'private';
        
        this.dockSetLoading = true;
        let [{ Reply: result, IN: res }] = await this.$mms.callMMS({
              topic: "",
              DDN: this.yp.ddn,
              func: this.dockIsNew ? "obj://add" : "obj://set",
              payload: this.dock
          });

          this.dockSetLoading = false;
          if(!result || result == ''){
              console.log(res.State);
              this.errorMsg = res.State.ErrMsg;
              this.errorLoading = true;
              return;
          }
          
          if(result.ErrMsg == 'OK'){
              console.log(result);
              this.dock = result.Data;
              this.dialogDockSetVisible = false;
              this.dockIsNew = false;
              this.snakText = "Dock Saved Successful";
              this.snackbar = true;
              //this.deleteObjectKey(result.Data);
          }else{
              this.errorMsg = result.ErrMsg;
              this.errorLoading = true;
          }
    },
    checkWebMMSState(){
        if(!this.mmsReady)
        {
          this.errorMsg = "WebMMS is not connected or registered.";
          this.errorLoading = true;
          return false;
        }else return  true;

      },
    startMMS(){
          // this.mms =  webmms({
          //   wsurl: conf.wsurl,
          //   EiToken: getCookie("brd-EiToken") || "",
          //   SToken: getCookie("brd-SToken") || ""
          // });
          
    },
    async subscribeMMS() {
        this.removeEvent = this.$mms.on("registered", async reply => {
            //console.log('reply=%s', JSON.stringify(reply))
             if(reply.ErrMsg == "OK"){
                this.eiInfo.ddn = reply.result.DDN;
                this.webmmsOptions.EiToken = reply.result.EiToken;
                this.webmmsOptions.SToken = reply.result.SToken;
                this.webmmsOptions.UToken = reply.result.UToken;
                if(this.eiInfo.eiName == ''){
                  this.eiInfo.eiName = reply.result.EiName ? reply.result.EiName : 'jbuilder-' + this.makeId(5);
                }
                 if(this.eiInfo.eiTag == ''){
                  this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : '';
                }
                this.mmsReady = true;
                this.error = false;
             }else{
                this.mmsReady = false;
                this.error = false;
             }

             let expiredTime = 60 * 60 * 24 * 30 * 12;

             setCookie("obj-EiToken", this.webmmsOptions.EiToken);
             setCookie("obj-SToken", this.webmmsOptions.SToken);


             console.log('regtoCenter: %s', reply.ErrMsg);

            let deviceInfo = {"DDN":this.eiInfo.ddn,"EiOwner":"","EiName":this.eiInfo.eiName,"EiType":".page","EiTag":this.eiInfo.eiTag,"EiLoc":""};
            let result = await this.$mms.setDeviceInfo(deviceInfo);

            console.log('SetDevice reply=%s', JSON.stringify(result));
        });

        this.$mms.on('message', (method, from, data, body) => {
             this.mmsReady = true;
             this.error = false;
             console.log('rcve: from=%s, data=%s', from, JSON.stringify(data));
            if(typeof data == 'object' && !data.from)
              data.from = from;
            //body.sender = data;
            if(data)
            {

              //this.eventList.push(data.data);
              //this.setLog({From : from, Data: data}, 'In');

            }
        });

        this.$mms.on('state', msg => {
            console.log('WS error: %s', msg);
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.$mms.on('disconnect', msg => {
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.$mms.on('error', err => {
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.$mms.on('connect_error', err => {
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.$mms.on('connect_timeout', err => {
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });
      },
  }
}
</script>
<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.logo{
  height: 30px;
}
.logo_txt{
  margin-left: 10px;
  vertical-align: super;
}
.board_icon{
  color: rgba(0, 0, 0, 0.31) !important;
}
.loading{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left:0;
  z-index: 50;
  background-color: rgba(255, 255, 255, 0.4196078431372549);
}
.header{
  box-shadow: none;
  border:none;
}
.header_title{
  font-weight:bold;
  font-size: 1.06em;
}

.header_margin{
  margin-left: 90px;
}
.header_btn{
      font-weight: bold;
    font-size: 13pt;
    text-transform: none;

}

.righ_form{
  padding-left: 15px;
  padding-right: 15px;
}
.dialog_form{
  padding: 15px;
}
.dialog_btn{
  text-transform: unset;
}

.form_btn{
  margin-bottom: 5px;
  text-transform: unset;
  min-width: 230px !important;
  position: absolute;
  left: 14px;
  bottom: 5px;
}
.form_btn i{
  font-size: 18px;
}
 .layoutHeader {
  min-height: 55px;
  line-height: 55px;
  background: #ffffff;
  box-shadow: 0 0 4px 2px #eaeaea;
}
.layoutFooter {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  min-height: 55px;
  line-height: 55px;
  background: #ffffff;
  box-shadow: 0 0 4px 2px #eaeaea;
}
.btn_add{
    /* bottom: 0;
    position: fixed;
    margin: 0 0 16px 16px;
    z-index: 5; */
    width: 30px !important;
    height: 30px !important;
}
.btn_add i{
  font-size: 20px !important;
}

.item-box{
  height: 100%;
  width: 94%;
}

</style>
<style>
/* .v-item-group.v-bottom-navigation--shift .v-btn .v-btn__content>:not(.v-icon){

} */
body{
  overflow: hidden;
}
.fill-height2{
  height: 90% ;
}
.btn_addBoard .v-icon{
  transform: translateY(0) !important;
  color: #1551d7 !important;
}
.btn_removeBoard .v-icon{
  transform: translateY(0) !important;
  color:#e6062f !important;
}
.box-card{
  height: 100%;
}
.dialog_form .v-text-field__details{
    display: none;
}
.dialog_card .v-card__title{
  padding: 5px 15px 5px;
  font-size: 12pt !important;
    font-weight: bold;
  position: relative;
}
.card_action_json{
  padding:5px;
  padding-right:10px;
  position:absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #e3e3e3;
  background-color: #ffffff;
}
.v-navigation-drawer__content{
  position: relative;
}
/* .btn_menu{
  height:100% !important;
  max-width: 10% !important;
  min-width: 10% !important;
}
.btn_menu img{height: 55% !important;}
.v-item-group.v-bottom-navigation--shift .v-btn--active .v-btn__content>.v-icon{
  transform: translateY(-10%) !important;
}
.v-item-group.v-bottom-navigation--shift .v-btn--active .v-btn__content>:not(.v-icon){
  top: calc(100% - 28%) !important;
} */
</style>